import { TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { forkJoin, catchError, of, Subject, debounceTime, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { Severity, VENDOR_OBJ_ID } from 'src/app/inventory/constants/constants';
import { ProductsService } from 'src/app/inventory/products/products.service';
import { PurchasesService } from 'src/app/inventory/purchases/purchases.service';
import { UtilsService } from 'src/app/inventory/purchases/utility/utils.service';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import { Status } from '../../models/status';
import { ProductDataService } from '../../services/product-data.service';
import data from '../../../../inventory/staticJSON/settings-column.json';
import { ImportserialService } from '../../services/importserial.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { SalesOrderService } from 'src/app/inventory/sales-order/sales-order.service';
import { UtilityService } from '../../../../inventory/sales-order/utils/utility.service';
import { BillingPrintComponent } from '../billing-print/billing-print.component';
import { IPostingPeriodDetails } from '../posting-period-selector/models/posting-period.model';
import { TaxSelectionModel } from '../tax-selection-modal/models/tax.model';
@Component({
  selector: 'app-edit-bill',
  templateUrl: './edit-bill.component.html',
  styleUrls: ['./edit-bill.component.scss']
})
export class EditBillComponent implements OnChanges, OnInit {

  @Input() selectedBill: any = null;
  @Input() companyInfo: any = null;
  @Input() isEdit: boolean = false;
  @Input() selectedChannel = null;
  @Input() mode: 'EDIT' | 'COPY' | 'VIEW' | 'PRINT' | 'EMAIL' = 'EDIT';
  @Output() onClose = new EventEmitter<boolean>();
  @Output() loadList = new EventEmitter<boolean>();
  poSerialEnabled: boolean = false;
  length: number = 0;
  qtyDecimal: number = 0;
  previousExchangeRate: number = 0;
  billTemplate;
  allDiscounts = [];
  allFOBPoints = [];
  uomCategory = [];
  displayNewBill: boolean = false;
  billPrintDetails: any = null;
  emailDialogHeader: string = '';
  displayNewEmail: boolean = false;
  emailAttachments: any[] = [];
  emailFrom = '';
  emailTo = '';
  emailCC = '';
  emailBCC = '';
  emailSubject = '';
  emailContent = '';
  vendorObjectId = VENDOR_OBJ_ID;
  savedBill = null;
  allVendors = [];
  allVendorsDD: any[] = [];
  vendorDetails;
  ordersVendor;
  activeVendorAddresses: any[] = [];
  ordersVendorAddrNew = '';
  ordersVendorCityNew = '';
  ordersVendorStateNew = '';
  ordersVendorCountryNew = '';
  ordersVendorZipcodeNew = '';
  ordersVendorPhoneNew = '';
  ordersVendorContactNew = '';
  displayVendorAddress = false;
  selectedVendorAddress;
  shipAddress = null;
  isDisabled: boolean = false;
  minimumDate = new Date();
  vendorPaymentTermsDD: any[] = [];
  vendorShippingMethodsDD = [];
  vendorPaymentMethodsDD: any[] = [];
  financialAccounts = [];
  allShippingTerms = [];
  allShippingTermsDD = [];
  discountEnabled: boolean = false;
  productOwner = [];
  billForm: FormGroup;
  accountForm: FormGroup;
  selectedVendorDD = null;
  selectedVendorContact = null;
  displayVendorContact: boolean = false;
  addExpenseFlag: boolean = true;
  expenses = [];
  items = [];
  productChannels = [];
  selectedTBChannel;
  index = 0;
  displayAddExpense = false;
  expenseHeader;
  amountDue: number;
  amountExpense: number = 0;
  subTotal: number = 0;
  lineTotal: number = 0;
  discount: number = 0;
  tax: number = 0;
  discountAmount: number = 0;
  selectedValueOption = null;
  shippingAmount: number = 0;
  amountItem: number = 0;
  appValue;
  pageNumber: number = 1;
  pageSize: number = 15;
  rowsPerPageTB = [100, 200, 300, 500];
  productGlobalFilterInput: string = '';
  selectedProductsList: any[] = [];
  displayProductsTb = false;
  allProducts: any[] = [];
  allProductsData: any[] = [];
  noCaseFindOrLoadingText = "";
  bundleData2: any[] = [];
  productsData2: any[] = [];
  serviceData2: any[] = [];
  nonInventoryData2: any[] = [];
  allBundleData2: any[] = [];
  productsData: any[] = [];
  productsTB: any[] = [];
  productsTBCol: any[] = [];
  allNonInventoryData2: any[] = [];
  modelChanged = new Subject<string>();
  totalTBRecord = 0;
  allProducts2: any[] = [];
  allProductsData2: any[] = [];
  allServiceData2: any[] = [];
  selectedBundle;
  first: number = 0;
  isBundle: boolean = false;
  searchValue: string = '';
  selectedProductForScan;
  nameLists = [];
  autoGenerateLists = [];
  listLength: number = 0;
  savedOptionSelection;
  scanedProductsList = [];
  statementMessege: string = "";
  minDate: Date = new Date(1988, 0, 1);
  maxDate: Date = new Date(2050, 11, 31);
  //tracking 
  displayScanInfo: boolean = false;
  disabledSave: boolean = false;
  allChecked: boolean = false;
  trackingForm: FormGroup;
  isPrefix: boolean = false;
  isAutoGenerated: boolean = false;
  prefixValue: string = '';
  displayImport = false;
  importCount: number = 0;
  systemTrackingData = [];
  trackingOptions = [];
  currentPostingPeriodInfo! : IPostingPeriodDetails;
  updatedPostingPeriodInfo! : IPostingPeriodDetails;
  isAllowPostingPeriod: boolean = false;
  @ViewChild('editor') editor: any;
  @ViewChild('editCurrency') overlayPanel: OverlayPanel;
  @ViewChild(BillingPrintComponent) billingPrint: BillingPrintComponent;

  reCalculateNotEnabled: boolean = false;
  baseCurrency: any;
  orgCurrency = [];
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    /**tax**/
    taxSettings: any;
    taxConfig: any;
    allTaxRates: any[] = []; // account based taxes
    displayTaxSelectionDialog: boolean = false;
    selectedTax: any;
    appliedTax: any;
    currentProduct: any;
    currentProductType: string;
    taxDialogContext: 'product' | 'footer' | null = null;
    footerTaxEnabled: boolean = false;

  constructor(private appMainService: AppMainService, private purchaseService: PurchasesService, private productDataService: ProductDataService,
    private fb: FormBuilder, private app: AppMainComponent, public utilService: UtilsService, private titlecasePipe: TitleCasePipe,
    private productsService: ProductsService, private addyearPipe: AddYearPipe, private messageService: MessageService,
    private confirmationService: ConfirmationService, private importService: ImportserialService, private renderer: Renderer2,
    private salesOrderService: SalesOrderService, private utilityService: UtilityService) {
    this.modelChanged.pipe(
      debounceTime(700))
      .subscribe(() => {
        this.onGlobalSearch();
      })
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.billForm = this.fb.group({
      id: [0],
      vendorId: [0, [Validators.required]],
      contactId: [0],
      paymentTermId: [0],
      paymentMethodId: [0],
      shippingTermId: [0],
      shippingMethodId: [null],
      billDate: [new Date()],
      shippingAddressId: [0],
      userId: [0],
      amountDue: [null, [Validators.required]],
      dueDate: [0],
      notes: [''],
      referenceNo: ['']
    });
    this.accountForm = this.fb.group({
      id: [0],
      financialAccountId: [null, [Validators.required]],
      amount: [0, [Validators.required]],
      memo: [''],
    });
    this.prepareTrackingForm();
    if (changes.selectedBill?.currentValue) {
      this.ordersVendorAddrNew = '';
      this.ordersVendorCityNew = '';
      this.ordersVendorStateNew = '';
      this.ordersVendorCountryNew = '';
      this.ordersVendorZipcodeNew = '';
      this.ordersVendorContactNew = '';
      this.ordersVendorPhoneNew = '';

      const financialAccountObservable = this.purchaseService.getAllFinancialAccounts().pipe(catchError((error) => this.handleError("financialAccount", error)));
      const vendorObservable = this.purchaseService.getAllPOVendors().pipe(catchError((error) => this.handleError("Vendor", error)));
      const templateObservable = this.purchaseService.getPOConfigurations('Purchase').pipe(catchError((error) => this.handleError("Template", error)));
      const shippingTermsObservable = this.purchaseService.getShippingTermList().pipe(catchError((error) => this.handleError("ShippingTerm", error)));
      const fobPointsObservable = this.purchaseService.getFOBList().pipe(catchError((error) => this.handleError("FOB", error)));
      const discountsObservable = this.salesOrderService.getDiscounts(false).pipe(catchError((error) => this.handleError("Discount", error)));
      const trackingOptionsObservable = this.purchaseService.loadTrackingOptions().pipe(catchError((error) => this.handleError("tracking", error)));
      const uomCategoryObservable = this.purchaseService.loadAllUOMCategory().pipe(catchError((error) => this.handleError("uom", error)));
      const salesRepObservable = this.productsService.getProductOwner(this.app.companyId).pipe(catchError((error) => this.handleError("users", error)));
      forkJoin([financialAccountObservable, vendorObservable, templateObservable, shippingTermsObservable, fobPointsObservable,
        discountsObservable, trackingOptionsObservable, uomCategoryObservable, salesRepObservable]).subscribe(
          ([fAccountData, vendorData, templateData, shippingData, fobData, discountData, trackingOptionData, categoryData, salesRepData]) => {
            this.loadFinancialAccounts(fAccountData);
            this.allVendorsDD = vendorData;
            this.getPOSettings(templateData);
            this.loadShippingTerm(shippingData);
            this.loadFOBList(fobData);
            this.getAllDiscounts(discountData);
            this.getAllTrackingData(trackingOptionData);
            this.loadUOMCategory(categoryData);
            this.loadISettings();
            this.loadSalesRep(salesRepData);
            this.appMainService.isHideSpinner("loadData");
            this.getBillDetails(this.selectedBill?.id);
          },
          (error) => {
            this.appMainService.isHideSpinner("loadData");
            this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
          },
        );
      this.getProductsChannels('Product Type');
    }
  }
  getBaseCurrency() {
    this.importService
      .getOrgCurrency()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((value) => {
        if (value) {
          this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
          this.orgCurrency = value;
        }
      });
  }

  ngOnInit(): void {
    this.getBaseCurrency();
    this.importService.getDecimalValue().subscribe(value => {
      if (value) {
        this.length = value;
      }
    })

    this.importService.getQtyDecimalValue().subscribe(value => {
      if (value) {
        this.qtyDecimal = value;
      }
    })
  }

  private handleError(apiName: string, error: any) {
    this.appMainService.isHideSpinner("loadData");
    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
    return of(null);
  }

  getPOSettings(configs) {
    const purchaseTemplate = configs?.find(config => config.name == 'Purchase Template');
    if (purchaseTemplate?.configurationDetails.length > 0) {
      const allPurchaseTemplates = JSON.parse(purchaseTemplate?.configurationDetails[0].configJSONValue);
      this.billTemplate = allPurchaseTemplates?.find((t) => t.producttypeId == this.selectedChannel?.id);
    }
  }

  loadShippingTerm(terms) {
    this.allShippingTerms = terms;
    this.allShippingTermsDD = this.allShippingTerms?.filter(shTerm => shTerm.statusId == Status.Active);
  }

  getAllDiscounts(addDiscounts) {
    if (addDiscounts && addDiscounts.length > 0) {
      this.allDiscounts = addDiscounts?.map((l) => ({ ...l, additionalDescription: `${l.description}(${l.type.description})`, typeDescription: l.type.description }));
      this.selectedValueOption = null;
    }
  }

  getAllTrackingData(opt) {
    this.trackingOptions = opt;
  }

  loadFOBList(points) {
    if (points) {
      this.allFOBPoints = points;
    }
  }

  loadUOMCategory(cat) {
    if (cat) {
      this.uomCategory = cat;
    }
  }

  loadSalesRep(usersData) {
    if (usersData) {
      this.productOwner = usersData?.filter(user => user.statusId == Status.Active);
    }
  }

  openBillEditor() {
    this.mode = 'EDIT';
    this.billForm.enable();
  }

  loadISettings() {
    const settings = this.utilityService.getISettings();
    const settingsMap = new Map(settings?.map(s => [s.code, s.enabled]));
    this.poSerialEnabled = settingsMap.get('poserialenabled');
    this.isAllowPostingPeriod = settingsMap.get('posting') ?? false;
  }

  getBillDetails(billId) {
    this.items = [];
    this.reCalculateNotEnabled = false;
    this.appMainService.isShowSpinner('newbill');
    this.purchaseService.getBillById(billId).subscribe(res => {
      this.appMainService.isHideSpinner('newbill');
      this.savedBill = res;
      const currentYear = this.app._showDateTimeWithZone(this.savedBill?.billDate).getFullYear();
      this.minDate = new Date(currentYear, 0, 1);
      this.maxDate = new Date(currentYear, 11, 31);
      this.billForm.patchValue(res);
      this.getShipAddress(this.savedBill.warehouse);
      const filteredVendor = this.allVendorsDD.find(vendor => vendor.id === this.savedBill.vendorId);
      this.billForm.controls['vendorId'].setValue(filteredVendor);
      this.getSelectedVendorDetails(filteredVendor?.id);
      if (this.savedBill.shippingAddress) {
        this.ordersVendorAddrNew = this.savedBill?.shippingAddress?.streetAddress1 + '' + this.savedBill?.shippingAddress?.streetAddress2
        this.ordersVendorCityNew = this.savedBill?.shippingAddress?.city?.name;
        this.ordersVendorStateNew = this.savedBill?.shippingAddress?.state?.name;
        this.ordersVendorCountryNew = this.savedBill?.shippingAddress?.country?.name;
        this.ordersVendorZipcodeNew = this.savedBill?.shippingAddress?.zipCode;
      }
      if (res.contact) {
        this.ordersVendorContactNew = this.savedBill?.contact?.firstName + ' ' + this.savedBill?.contact?.lastName;
        this.ordersVendorPhoneNew = this.savedBill?.contact?.contactPhones[0]?.phone?.number
      }
      this.currentPostingPeriodInfo = {
        postingDate: this.app._showDateTimeWithZone(this.savedBill.postingDate),
        postingMonth: this.savedBill.postingMonth,
        postingYear: this.savedBill.postingYear
      };
      this.billTemplate = (res.configJson ? JSON.parse(res.configJson) : this.billTemplate);
      this.footerTaxEnabled = !this.billTemplate?.labels_table[5]?.isChecked && this.billTemplate?.labels_footer[4]?.isChecked;
      this.billForm.controls['billDate'].setValue(this.app._showDateTimeWithZone(this.savedBill.billDate));
      this.billForm.controls['dueDate'].setValue(this.app._showDateTimeWithZone(this.savedBill.dueDate));
      this.billForm.controls['amountDue'].setValue(Number(this.savedBill.billAmount) * Number(this.savedBill?.exchangeRate));
      this.billForm.controls['notes'].setValue(res.billOrderNotes?.length > 0 ? res.billOrderNotes[0].note?.comment : '');
      this.setContentInEditor(res.billOrderNotes?.length > 0 ? res.billOrderNotes[res?.billOrderNotes?.length - 1].note?.comment ?? "" : '');
      this.amountExpense = Number(res.totalExpenseAmount) * Number(this.savedBill?.exchangeRate);
      this.amountItem = Number(res.netAmount) * Number(this.savedBill?.exchangeRate);
      const filteredExpenses = [];
      for (let expense of res.billOrderExpense) {
        let financialAccount = this.getSavedFinancialAccount(this.financialAccounts, expense.financialAccountId);
        if (!financialAccount) {
          financialAccount = this.findSubChildAccount(this.financialAccounts, expense.financialAccountId);
        }
        const objEach = {
          financialAccountId: financialAccount,
          amount: Number(expense.amount) * Number(this.savedBill?.exchangeRate),
          memo: expense.description,
          id: expense.id,
        }
        filteredExpenses.push(objEach)
      }
      this.expenses = filteredExpenses;
      this.subTotal = Number(res.totalAmount) * Number(this.savedBill?.exchangeRate);
      this.shippingAmount = Number(res.shippingChargeAmount) * Number(this.savedBill?.exchangeRate);
      this.discount = Number(res.discountAmount) * Number(this.savedBill?.exchangeRate);
      this.tax = Number(res.taxAmount) * Number(this.savedBill?.exchangeRate);
      this.selectedValueOption = this.allDiscounts?.find(opt => opt.id == res.discountId);
      if (this.selectedValueOption?.type?.name == 'Percentage') {
        const discountTypeValue = Number(this.savedBill.discountAmount * 100) / Number(this.savedBill.totalAmount);
        this.discountAmount = (isNaN(discountTypeValue) ? 0 : discountTypeValue);
      } else {
        this.discountAmount = this.savedBill?.discountAmount;
      }
      if (res.billOrderProducts.length > 0) {
        for (let l of res.billOrderProducts) {
          const bundleProducts: any[] = [];
          if (l.billOrderBundleDetail?.length > 0) {
            for (let prd of l.billOrderBundleDetail) {
              let eachProduct = {
                id: prd.id,
                poNo: prd.purchaseOrderNo,
                productId: prd.productId,
                subProductId: prd.subProductId,
                purchaseOrderId: prd.purchaseOrderId,
                billOrderProductId: prd.billOrderProductId,
                itemNo: prd.product?.itemNo,
                typeId: prd.products?.typeId,
                description: prd?.product?.description,
                availabel: prd.orderedQty,
                originalQty: prd.originalQty,
                unit: prd.product?.productUOM?.find(uom => uom.unitOfMeasureId == prd.productUnitId),
                uom: prd.product?.productUOM,
                cost: parseFloat(prd.totalAmount).toFixed(this.length),
                price: parseFloat(prd.pricePerProduct).toFixed(this.length),
                trackingEnabled: prd.product?.isTrackingRequired,
                serialSettings: (prd.product?.serialSettings ? JSON.parse(prd.product?.serialSettings) : null),
                billOrderBundleSerialDetail: prd.billOrderBundleSerialDetail,
                serialCount: prd.serialCount
              };
              bundleProducts.push(eachProduct);
            }
          }
          let eachProduct = {
            id: l.id,
            billOrderProductId: l.id,
            poNo: l.purchaseOrderNo,
            purchaseOrderId: l.purchaseOrderId,
            productId: l.productId,
            itemNo: l.product?.itemNo,
            description: l?.description,
            uom: l.product?.productUOM,
            unit: l.product?.productUOM?.find(uom => uom.unitOfMeasureId == l.productUnitId),
            warehouseId: l.warehouseId,
            availabel: l.orderedQty,
            originalQty: l.orderedQty,
            price: Number((l.pricePerProduct) * Number(this.savedBill?.exchangeRate)).toFixed(this.length),
            cost: Number(l.totalAmount) * Number(this.savedBill?.exchangeRate),
            lineTotal: Number(l.netAmount) * Number(this.savedBill?.exchangeRate),
            typeId: l.product?.typeId,
            trackingEnabled: l.product?.isTrackingRequired,
            serialSettings: (l.product?.serialSettings ? JSON.parse(l.product?.serialSettings) : null),
            billOrderSerialDetail: this.mode == 'COPY' ? [] : l.billOrderSerialDetail,
            products: bundleProducts,
            serialCount: l.serialCount,
            productSubTax: l.billOrderProductSubTax,
            taxAmount: l.billOrderProductSubTax?.reduce((sum, s) => sum + (Number(s.taxAmount) * this.savedBill?.exchangeRate), 0).toFixed(this.length)
          };
          this.items.push(eachProduct);
        }
      }
      this.index = this.expenses?.length ? 0 : 1;
      this.items = [...this.items];
      this.lineTotal = this.items.reduce((sum, item) => sum + item.lineTotal, 0);
      if (this.mode == 'VIEW') {
        this.billForm.disable();
        this.displayNewBill = true;
      } else if (this.mode != 'PRINT' && this.mode != 'EMAIL') {
        this.displayNewBill = true;
      } else if (this.mode == 'PRINT' || this.mode == 'EMAIL') {
        this.billPrint()
      }
    });
  }

  billPrint() {
    this.billPrintDetails = {
      items: this.items,
      selectedBill: this.selectedBill,
      savedBill: this.savedBill,
      ordersVendorAddrNew: this.ordersVendorAddrNew,
      ordersVendorCityNew: this.ordersVendorCityNew,
      ordersVendorCountryNew: this.ordersVendorCountryNew,
      ordersVendorStateNew: this.ordersVendorStateNew,
      ordersVendorZipcodeNew: this.ordersVendorZipcodeNew,
      ordersVendorContactNew: this.ordersVendorContactNew,
      ordersVendorPhoneNew: this.ordersVendorPhoneNew,
      expenses: this.expenses,
      subTotal: this.subTotal,
      shippingAmount: this.shippingAmount,
      discount: this.discount,
      discountAmount: this.discountAmount
    };
    setTimeout(() => {
      switch (this.mode) {
        case 'PRINT':
          this.billingPrint.print();
          this.onClose.emit();
          break;
        case 'EMAIL':
          this.displayNewEmail = true;
          this.openEmailDialog();
          break;
      }
    }, 1000);
  }

  openEmailDialog() {
    const emailTo = this.savedBill?.vendor?.vendorContacts?.find(contact => contact.contact?.isPrimaryContact === true);
    this.emailAttachments = [];
    this.emailSubject = "";
    this.emailTo = "";
    let customerName = "";
    let moduleName = "";
    this.emailTo = emailTo?.contact?.contactEmails?.length > 0 ? emailTo?.contact?.contactEmails[0].email.emailAddress : '';
    this.emailDialogHeader = "Send Bill Email";
    const attachmentName = "Bill No." + this.savedBill.number;
    this.emailSubject = "Bill No.:" + this.savedBill?.number;
    const attachment = this.billingPrint.getPDF();
    const obj = {
      name: attachmentName + ".pdf",
      attachment: attachment,
      extension: ".pdf",
    };
    this.emailAttachments.push(obj);
    moduleName = "Bill";
    customerName = this.selectedBill?.name;
    this.emailContent = `<p>Dear ${customerName} ,</p><br/><p>Please review the attached ${moduleName}. Feel free to contact us if you have any questions.</p><br/><p>We look forward to working with you.</p><br/><br/><p>Sincerely,</p><br/><p>${this.app?.user?.organizationName
      }</p><br/><p>${""}</p>`;
  }

  onEmailCancel(e) {
    this.onClose.emit();
    this.displayNewEmail = false;
  }

  onEmailSendComplete(e) {
    this.onClose.emit();
    this.displayNewEmail = false;
  }

  isClosingStatementDate(event: string) {
    this.statementMessege = event;
  }

  getSavedFinancialAccount(list, savedParam) {
    //For Child Financial Account
    for (let ac of list) {
      const childAccount = ac.children?.find(
        (child) => child.value?.id == savedParam
      );
      if (childAccount) {
        return childAccount;
      }
    }
    //For Sub-Child Financial Account
    for (let cls of list) {
      for (let element of cls.children) {
        const subChildAccount = element.children?.find(
          (child) => child.value?.id == savedParam
        );
        if (subChildAccount) {
          return subChildAccount;
        }
      }
    }
  }

  findSubChildAccount(list, savedParam) {
    //For fourth level Sub-Child Financial Account
    let financialAccount = null;
    for (let cls of list) {
      for (let element of cls.children) {
        element?.children?.forEach(subChild => {
          const subChildAccount = subChild?.children?.find((child) => child?.value?.id == savedParam);
          if (subChildAccount) {
            financialAccount = subChildAccount;
          }
        });
      }
    }
    return financialAccount;
  }

  calculateDueDate() {
    const duedate = this.utilService.getDueDate(this.billForm.controls['paymentTermId'].value?.paymentTerm, this.billForm.controls["billDate"].value);
    const dateUser = this.app._showDateTimeWithZone(duedate);
    if ((duedate)) {
      this.billForm.controls['dueDate'].setValue(dateUser);
    } else {
      const date = this.app._showDateTimeWithZone(new Date());
      this.billForm.controls['dueDate'].setValue(date);
    }
  }

  get vendorExchangeRate() {
    return (this.savedBill?.exchangeRate);
  }

  showEditExchangeRate(event) {
    this.overlayPanel.toggle(event);
    this.reCalculateNotEnabled = false;
  }

  closeCurrencyDialog(value) {
    if (!value.formData) return; // Ensure value is defined
    const { defaultRateEnabled, enableRecalculateItemRate, exchangeRate } = value.formData;

    if (!defaultRateEnabled && enableRecalculateItemRate) {
      this.savedBill.exchangeRate = exchangeRate;
      this.reCalculatePrices(value);
    } else if (defaultRateEnabled) {
      this.savedBill.exchangeRate = exchangeRate;

      if (enableRecalculateItemRate) {
        this.reCalculatePrices(value);
      } else {
        this.reCalculateNotEnabled = true;
        this.previousExchangeRate = value.previousExchangeRate;
      }
    }
    this.overlayPanel.hide();
  }

  reCalculatePrices(value) {
    this.items?.map(prd => {
      prd.price = Number(prd.price * this.vendorExchangeRate) / Number(value.previousExchangeRate);
      prd.cost = Number(prd.availabel) * Number(prd.price);
      let productsTotalTax = 0;
      prd?.productSubTax?.forEach((sTax) => {
          productsTotalTax += this.utilService.calculateProductsTax(sTax.taxRate, prd.cost);
      });
      prd.taxAmount = productsTotalTax;
      prd.lineTotal = Number(prd.cost) + productsTotalTax;
    })
    this.calculateItemExpense();
  }

  getSelectedVendorDetails(vendorId) {
    this.appMainService.isShowSpinner('vendor');
    this.purchaseService.getVendorById(vendorId).subscribe(value => {
      this.vendorDetails = value;
      //Active Vendor Payment Term
      this.vendorPaymentTermsDD = this.vendorDetails?.vendorPaymentTerm?.filter(term => term.statusId == Status.Active);
      const inActivePaymnetTerm = this.vendorPaymentTermsDD?.find(v => v.paymentTermId == this.savedBill?.paymentTermId);
      if (!inActivePaymnetTerm && this.savedBill?.paymentTerm) {
        const obj = {
          paymentTermId: this.savedBill?.paymentTerm?.id,
          statusId: this.savedBill?.paymentTerm?.statusId,
          paymentMethodTerm: this.savedBill?.paymentTerm?.name
        }
        this.vendorPaymentTermsDD.push(obj);
      }
      // Payment Term which is not part of vendor (WF PO)
      const nonVendorPaymentTerm = this.vendorDetails?.vendorPaymentTerm?.find(v => v.paymentTermId == this.savedBill?.paymentTermId);
      if (!nonVendorPaymentTerm && this.savedBill?.paymentTerm) {
        const obj = {
          paymentTermId: this.savedBill?.paymentTerm?.id,
          statusId: this.savedBill?.paymentTerm?.statusId,
          paymentMethodTerm: this.savedBill?.paymentTerm?.name
        }
        this.vendorPaymentTermsDD.push(obj);
      }
      //Set Payment Term
      this.billForm.controls['paymentTermId'].setValue(this.vendorPaymentTermsDD?.find(term => term.paymentTermId == this.savedBill.paymentTermId));
      //Active Vendor Payment Method
      this.vendorPaymentMethodsDD = this.vendorDetails?.vendorPaymentMethod?.filter(method => method.statusId == Status.Active);
      const inActivePaymentMethod = this.vendorPaymentMethodsDD?.find(v => v.paymentMethodId == this.savedBill?.paymentMethodId);
      if (!inActivePaymentMethod && this.savedBill?.paymentMethod) {
        const obj = {
          paymentMethodId: this.savedBill?.paymentMethod?.id,
          statusId: this.savedBill?.paymentMethod?.statusId,
          paymentMethodMethod: this.savedBill?.paymentMethod?.name
        }
        this.vendorPaymentMethodsDD.push(obj);
      }
      // Payment Method which is not part of vendor (WF PO)
      const nonVendorPaymentMethod = this.vendorDetails?.vendorPaymentMethod?.find(v => v.paymentMethodId == this.savedBill?.paymentMethodId);
      if (!nonVendorPaymentMethod && this.savedBill?.paymentMethod) {
        const obj = {
          paymentMethodId: this.savedBill?.paymentMethod?.id,
          statusId: this.savedBill?.paymentMethod?.statusId,
          paymentMethodMethod: this.savedBill?.paymentMethod?.name
        }
        this.vendorPaymentMethodsDD.push(obj);
      }
      //Set Payment Method
      this.billForm.controls['paymentMethodId'].setValue(this.vendorPaymentMethodsDD?.find(method => method.paymentMethodId == this.savedBill.paymentMethodId));
      //Active Vendor Shipping Method
      this.vendorShippingMethodsDD = this.vendorDetails?.vendorShippingMethod?.filter(shipping => shipping.statusId == Status.Active);
      const inActiveShippingMethod = this.vendorShippingMethodsDD?.find(v => v.shippingMethodId == this.savedBill?.shippingMethodId);
      if (!inActiveShippingMethod && this.savedBill?.shippingMethod) {
        const obj = {
          shippingMethodId: this.savedBill?.shippingMethod?.id,
          statusId: this.savedBill?.shippingMethod?.statusId,
          shippingMethodName: this.savedBill?.shippingMethod?.name
        }
        this.vendorShippingMethodsDD.push(obj);
      }
      // Shipping Method which is not part of vendor (WF PO)
      const nonVendorShippingMethod = this.vendorDetails?.vendorShippingMethod?.find(v => v.shippingMethodId == this.savedBill?.shippingMethodId);
      if (!nonVendorShippingMethod && this.savedBill?.shippingMethod) {
        const obj = {
          shippingMethodId: this.savedBill?.shippingMethod?.id,
          statusId: this.savedBill?.shippingMethod?.statusId,
          shippingMethodName: this.savedBill?.shippingMethod?.name
        }
        this.vendorShippingMethodsDD.push(obj);
      }
      //Set Shippong Method
      this.billForm.controls['shippingMethodId'].setValue(this.vendorShippingMethodsDD?.find(method => method.shippingMethodId == this.savedBill?.shippingMethodId));
      //Active Vendor Shipping Term
      this.allShippingTermsDD = this.allShippingTerms?.filter(term => term.statusId == Status.Active);
      const inActiveShippingTerm = this.allShippingTermsDD?.find(v => v.id == this.savedBill?.shippingTermId);
      if (!inActiveShippingTerm && this.savedBill?.shippingTerm) {
        this.allShippingTermsDD.push(this.savedBill?.shippingTerm);
      }
      //Set Shipping Term
      this.billForm.controls['shippingTermId'].setValue(this.allShippingTermsDD?.find(term => term.id == this.savedBill.shippingTermId));
      this.appMainService.isHideSpinner('vendor');
    })
  }

  onChangeVendor(value, type) {
    const activeVendorAddresses = value.vendorAddresses?.filter(add => add.statusId == Status.Active); //Active Address
    if (activeVendorAddresses.length > 1 && type == 'edit') {
      this.selectedVendorDD = value;
      this.selectedVendorDD.vendorAddresses = value.vendorAddresses?.filter(add => add.statusId == Status.Active); //Active Address
      this.selectedVendorAddress = this.selectedVendorDD.vendorAddresses?.find(add => add.addressId == this.billForm.controls['shippingAddressId'].value);
      this.displayVendorAddress = true;
    } else {
      this.ordersVendorAddrNew = '';
      this.ordersVendorCityNew = '';
      this.ordersVendorStateNew = '';
      this.ordersVendorCountryNew = '';
      this.ordersVendorZipcodeNew = '';
      this.ordersVendorPhoneNew = '';
      this.ordersVendorContactNew = '';
      for (let vendorContact of value.vendorContacts) {
        if (vendorContact.contact?.isPrimaryContact) {
          this.billForm.controls['contactId'].setValue(vendorContact.contactId);
          this.ordersVendorPhoneNew = vendorContact.contact?.contactPhones[0]?.phone?.number;
          this.ordersVendorContactNew = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
        }
      }
    }
  }

  async getShipAddress(location) {
    this.shipAddress = location;
    await this.getTaxByAddress(location.address?.countryId);
  }

  changeVendorContact() {
    this.selectedVendorContact = null;
    this.selectedVendorContact = this.vendorDetails?.vendorContacts?.find(contact => contact.contactId == this.billForm.controls['contactId'].value);
    this.displayVendorContact = true;
  }

  onRowSelectContact() {
    this.billForm.controls['contactId'].setValue(this.selectedVendorContact.contactId);
    this.ordersVendorPhoneNew = this.selectedVendorContact.contact?.contactPhones[0]?.phone?.number;
    this.ordersVendorContactNew = this.selectedVendorContact.contact?.firstName + " " + this.selectedVendorContact.contact?.lastName;
    this.displayVendorContact = false;
  }

  onRowSelectAddress(value) {
    this.displayVendorAddress = false;
    this.billForm.controls['shippingAddressId'].setValue(this.selectedVendorAddress.addressId);
    this.ordersVendorAddrNew = (this.selectedVendorAddress.address?.streetAddress1 == '') ? this.selectedVendorAddress.address?.streetAddress2 : (this.selectedVendorAddress.address?.streetAddress1 + ' ' + this.selectedVendorAddress.address?.streetAddress2);
    this.ordersVendorCityNew = this.selectedVendorAddress.address?.city?.name;
    this.ordersVendorStateNew = this.selectedVendorAddress.address?.state?.name;
    this.ordersVendorCountryNew = this.selectedVendorAddress.address?.country?.name;
    this.ordersVendorZipcodeNew = this.selectedVendorAddress.address?.zipCode;
    if (this.selectedVendorAddress.address.attnContactId) {
      for (let vendorContact of this.vendorDetails?.vendorContacts) {
        if (vendorContact.contactId == this.selectedVendorAddress.address.attnContactId) {
          this.ordersVendorPhoneNew = vendorContact.contact?.contactPhones[0]?.phone?.number;
          this.ordersVendorContactNew = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
          this.billForm.controls['contactId'].setValue(vendorContact.contactId);
        }
      }
    } else {
      for (let vendorContact of this.vendorDetails?.vendorContacts) {
        if (vendorContact.contact?.isPrimaryContact) {
          this.ordersVendorPhoneNew = vendorContact.contact?.contactPhones[0]?.phone?.number;
          this.ordersVendorContactNew = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
          this.billForm.controls['contactId'].setValue(vendorContact.contactId);
        }
      }
    }
  }

  prepareExpenseForm() {
    this.accountForm = this.fb.group({
      id: [0],
      financialAccountId: [null, [Validators.required]],
      amount: [0, [Validators.required]],
      memo: [''],
    });
  }

  addExpense() {
    this.expenseHeader = "Add Expense";
    this.addExpenseFlag = true;
    this.prepareExpenseForm();
    this.displayAddExpense = true;
  }

  editExpense(expense) {
    this.expenseHeader = "Edit Expense";
    this.addExpenseFlag = false;
    this.prepareExpenseForm();
    this.accountForm.patchValue(expense);
    this.displayAddExpense = true;
  }

  saveExpense(value) {
    if (value.amount == 0) {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Amount must be greater than 0..." });
      return
    }
    //check expense flag to add/update
    if (this.addExpenseFlag) {
      this.expenses.push(value);
    } else {
      const index = this.expenses?.findIndex(exp => exp.id == value.id);
      this.expenses[index] = value;
    }
    this.calculateExpense();
    this.displayAddExpense = false;
  }

  calculateExpense() {
    this.amountExpense = 0;
    for (let exp of this.expenses) {
      this.amountExpense = this.amountExpense + exp.amount;
    }
    const amoutDue = Number(this.amountExpense) + Number(this.amountItem);
    this.billForm.controls['amountDue'].setValue(amoutDue);
  }

  calculateItemExpense() {
    this.amountItem = 0;
    this.subTotal = 0;
    this.lineTotal = 0;
    this.tax = 0;
    this.subTotal = this.items?.reduce((sum, s) => sum + Number(s.cost), 0) ?? 0;
    this.lineTotal = this.items?.reduce((sum, s) => sum + Number(s.lineTotal), 0) ?? 0;
    this.tax = this.items?.reduce((sum, s) => sum + Number(s.taxAmount), 0) ?? 0;
    this.findsum();
  }

  findsum(addDiscount?) {
    this.discount = 0;
    if (addDiscount === false) {
      this.discountAmount = this.selectedValueOption?.discountValue;
    }
    if (this.selectedValueOption?.type?.name == "%" || this.selectedValueOption?.type?.name == "Percentage") {
      this.discount = this.discount + Number(this.subTotal * (Number(this.discountAmount) / 100));
    } else if (this.selectedValueOption?.type?.name == "$" || this.selectedValueOption?.type?.name == "Amount") {
      this.discount = this.discountAmount;
    }
    this.amountItem = Number((this.lineTotal + (this.subTotal > 0 ? Number(this.shippingAmount) : 0)) +
    (this.footerTaxEnabled ? this.tax : 0)  - this.discount);
    const amoutDue = Number(this.amountExpense) + Number(this.amountItem);
    this.billForm.controls['amountDue'].setValue(amoutDue);
  }

  removeItem(index, type) {
    if (type == 'item') {
      this.items.splice(index, 1);
      this.calculateItemExpense();
    } else {
      this.expenses.splice(index, 1);
      this.calculateExpense();
    }
  }

  loadFinancialAccounts(accounts) {
    let data = []
    for (let c of accounts) {
      let ChildData = [];
      for (let s of c.childAccounts) {
        let subData = [];
        for (let subb of s.childAccounts) {
          let childSubbData = [];
          for (let subChild of subb.childAccounts) {
            if (subChild.statusId == 1) {
              let eachSubChild = {
                label: `${subChild.displayNumber || ""} - ${subChild.name}`,
                value: subChild,
                selectable: true,
                children: [],
              };
              childSubbData.push(eachSubChild);
            }
          }
          //if (subb.statusId == 1) {
          let eachSub = {
            label: `${subb.displayNumber || ""} - ${subb.name}`,
            value: subb,
            children: childSubbData,
          };
          subData.push(eachSub);
          //}
        }
        let eachSub = {
          label: `${s.displayNumber || ""} - ${s.name}`,
          value: s,
          children: subData
        }
        ChildData.push(eachSub)
      }

      let eachData = {
        label: `${c.displayNumber || ""} - ${c.name}`,
        selectable: false,
        value: c,
        children: ChildData
      }
      data.push(eachData)
    }
    this.financialAccounts = data;
  }

  onTableChanged(event) {
    this.modelChanged.next("");
  }

  onGlobalSearch() {
    this.pageNumber = 1;
    this.searchValue = this.productGlobalFilterInput;
    const vendorId = this.billForm.controls['vendorId'].value?.id;
    this.getAllProducts2(this.selectedTBChannel.id, this.pageNumber, this.pageSize, vendorId, this.searchValue)
  }

  getProductsChannels(name) {
    this.productsService.getAllProductChannel(name).subscribe(channels => {
      const config = JSON.parse(channels.configurationDetails[0].configJSONValue);
      this.productChannels = config.filter((el) => !['Kit/Package Items', 'Bundle Item'].includes(el.name));
      this.selectedTBChannel = this.productChannels?.find(ch => ch.isDefault);
    });
  }

  changeTBChannel() {
    this.productGlobalFilterInput = "";
    this.pageNumber = 1;
    const vendorId = this.billForm.controls['vendorId'].value?.id;
    this.getAllProducts2(this.selectedTBChannel.id, this.pageNumber, this.pageSize, vendorId, '');
  }


  getAllProducts2(typeId, pageNumber, pageSize, vendorId, searchValue) {
    this.purchaseService
      .getAllProductsBySearch(typeId, pageNumber, pageSize, vendorId, searchValue)
      .then((products) => {
        let { inventory, headers } = products;
        inventory = inventory ?? [];
        headers = headers ?? [];
        this.totalTBRecord = headers["TotalCount"];
        this.allProducts = inventory;
        this.allProductsData2 = [];
        this.productsData2 = [];
        if (inventory.length > 0) {
          if (this.selectedTBChannel.name == "Inventory Item") {
            for (let l of inventory) {
              let eachProduct = {
                id: 0,
                itemNo: l.itemNo,
                productId: l.id,
                description: l.description,
                uom: l.productUOM,
                unit: l.productUOM[0],
                availabel: 1,
                originalQty: 1,
                qoh: l.productCount?.totalQty,
                typeId: l.typeId,
                cost: (l.warehouseProduct?.length > 0 ? parseFloat(l.warehouseProduct[0].buyPrice).toFixed(this.length) :
                  parseFloat(l.productPrice?.buyPrice).toFixed(this.length)),
                price: (l.warehouseProduct?.length > 0 ? parseFloat(l.warehouseProduct[0].buyPrice).toFixed(this.length) :
                  parseFloat(l.productPrice?.buyPrice).toFixed(this.length)),
                trackingEnabled: l.isTrackingRequired,
                isTrackingRequired: l.isTrackingRequired ? 'Yes' : 'No',
                serialSettings: (l.serialSettings ? JSON.parse(l.serialSettings) : null),
                billOrderSerialDetail: null,
                serialCount: 0
              };
              this.allProductsData2.push(eachProduct);
            }
            this.productsData2 = this.allProductsData2;
            this.productsTB = this.productsData2;
            this.productsTBCol = data.bundle_product_table_column;
          } else if (this.selectedTBChannel.name == "Service") {
            this.allServiceData2 = [];
            for (let l of inventory) {
              let eachService = {
                id: 0,
                productId: l.id,
                itemNo: l.itemNo,
                availabel: 1,
                originalQty: 1,
                qoh: l.availableQty,
                description: l.description,
                uom: l.productUOM,
                unit: l.productUOM[0],
                price: (l.warehouseProduct?.length > 0 ? parseFloat(l.warehouseProduct[0].buyPrice).toFixed(this.length) :
                  parseFloat(l.productPrice?.buyPrice).toFixed(this.length)),
                typeId: l.typeId,
                trackingEnabled: false,
                serialSettings: (l.serialSettings ? JSON.parse(l.serialSettings) : null),
                serialCount: 0
              };
              this.allServiceData2.push(eachService);
            }
            this.serviceData2 = this.allServiceData2;
            this.productsTB = this.serviceData2;
            this.productsTBCol = data.bundle_product_table_column;
          } else if (this.selectedTBChannel.name == "Non Inventory Item") {
            this.allNonInventoryData2 = [];
            for (let l of inventory) {
              let eachNonInventory = {
                id: 0,
                productId: l.id,
                itemNo: l.itemNo,
                availabel: 1,
                originalQty: 1,
                qoh: l.availableQty,
                uom: l.productUOM,
                unit: l.productUOM[0],
                description: l.description,
                cost: (l.warehouseProduct?.length > 0 ? parseFloat(l.warehouseProduct[0].buyPrice).toFixed(this.length) :
                  parseFloat(l.productPrice?.buyPrice).toFixed(this.length)),
                price: (l.warehouseProduct?.length > 0 ? parseFloat(l.warehouseProduct[0].buyPrice).toFixed(this.length) :
                  parseFloat(l.productPrice?.buyPrice).toFixed(this.length)),
                typeId: l.typeId,
                trackingEnabled: false,
                serialSettings: (l.serialSettings ? JSON.parse(l.serialSettings) : null),
                serialCount: 0
              };
              this.allNonInventoryData2.push(eachNonInventory);
            }
            this.nonInventoryData2 = this.allNonInventoryData2;
            this.productsTB = this.nonInventoryData2;
            this.productsTBCol = data.non_Inv_product_table_column;
          } else if (this.selectedTBChannel.name == "Bundle Item") {
            this.allBundleData2 = [];
            for (let l of inventory) {
              const bundleProducts: any[] = [];
              for (let prd of l.productBundleLink) {
                let eachProduct = {
                  id: 0,
                  productId: prd.productId,
                  subProductId: prd.subProductId,
                  itemNo: prd.itemNo,
                  description: prd.description,
                  availabel: prd.qty,
                  originalQty: prd.qty,
                  qoh: prd.availableQty,
                  uom: prd.productUOM,
                  unit: prd.productUOM?.find(data => data.unitOfMeasureId == prd.uomId),
                  cost: parseFloat(prd.costPrice).toFixed(this.length),
                  price: parseFloat(prd.costPrice).toFixed(this.length),
                  trackingEnabled: prd.isTrackingRequired,
                  serialSettings: (l.serialSettings ? JSON.parse(l.serialSettings) : null),
                  billOrderBundleSerialDetail: null,
                  serialCount: 0
                };
                bundleProducts.push(eachProduct);
              }

              let eachBundle = {
                id: 0,
                productId: l.id,
                itemNo: l.itemNo,
                availabel: 1,
                originalQty: 1,
                qoh: l.availableQty,
                uom: l.productUOM,
                unit: l.productUOM[0],
                description: l.description,
                cost: (l.warehouseProduct?.length > 0 ? parseFloat(l.warehouseProduct[0].buyPrice).toFixed(this.length) :
                  parseFloat(l.productPrice?.buyPrice).toFixed(this.length)),
                price: (l.warehouseProduct?.length > 0 ? parseFloat(l.warehouseProduct[0].buyPrice).toFixed(this.length) :
                  parseFloat(l.productPrice?.buyPrice).toFixed(this.length)),
                typeId: l.typeId,
                purchaseOrderProductId: 0,
                products: bundleProducts,
                trackingEnabled: false,
                billOrderSerialDetail: []
              };
              this.allBundleData2.push(eachBundle);
            }
            this.bundleData2 = this.allBundleData2;
            this.productsTB = this.bundleData2;
            this.productsTBCol = data.bun_product_table_column
          }
          this.displayProductsTb = true;
        } else {
          this.noCaseFindOrLoadingText = "No Products found.";
          this.bundleData2 = [];
          this.productsData2 = [];
          this.serviceData2 = [];
          this.nonInventoryData2 = [];
          this.productsTB = [];
        }
      })
      .finally(() => {
        this.noCaseFindOrLoadingText = "No Products found.";
      });
  }

  getTBData(event) {
    this.pageNumber = event.first / event.rows + 1;
    this.first = event.first;
    const vendorId = this.billForm.controls['vendorId'].value?.id;
    this.getAllProducts2(this.selectedTBChannel.id, this.pageNumber, this.pageSize, vendorId, this.searchValue);
  }

  openProducts(type?, bundle?) {
    if (type) {
      this.isBundle = true;
      this.selectedBundle = bundle;
    }
    this.selectedProductsList = this.items;
    this.first = 0;
    const vendorId = this.billForm.controls['vendorId'].value?.id;
    this.pageNumber = 1;
    this.getAllProducts2(this.selectedTBChannel.id, this.pageNumber, this.pageSize, vendorId, '');
  }

  addProduct() {
    for (let prd of this.selectedProductsList) {
      const alreadyExist = this.items?.find(d => d.id == prd.id);
      if (!alreadyExist) {
        prd.price = (prd.price * this.savedBill?.exchangeRate);
        prd.cost = (prd.price * prd.availabel);
        prd.productSubTax = (this.footerTaxEnabled ? (this.items[0]?.productSubTax ?? []) : []);
        prd.taxAmount = 0;
        if (this.footerTaxEnabled) {
          let productsTotalTax = 0;
          prd?.productSubTax?.forEach((sTax) => {
            productsTotalTax += this.utilService.calculateProductsTax(sTax.taxRate, prd.cost);
          });
          prd.taxAmount = productsTotalTax;
        }
        prd.lineTotal = (prd.price * prd.availabel);
        prd.referenceId = '';
        this.items.push(prd);
      }
    }
    //remove deselected items from list
    const unmatched = this.items?.filter(item => !this.selectedProductsList?.some(_item => _item.id === item.id));
    for (let prd of unmatched) {
      const index = this.items?.indexOf(prd);
      this.items?.splice(index, 1);
    }
    this.calculateItemExpense();
    this.displayProductsTb = false;
  }

  setBillExpense() {
    const expenses = [];
    this.expenses.forEach(element => {
      const expenseEach = {
        id: (element.id ?? 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        financialAccountId: element.financialAccountId?.value?.id,
        amount: element.amount,
        description: element.memo,
        accountId: 0,
        billable: true,
        classId: 0,
        statusId: 1,
        billOrderId: this.savedBill?.id
      }
      expenses.push(expenseEach);
    });
    return expenses;
  }

  setNotes(value) {
    const note: any[] = [];
    if (value.notes) {
      const notes = {
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        billOrderId: 0,
        userId: (value.userId ?? 0),
        noteId: 0,
        note: {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          comment: value.notes,
          isImportant: true,
          organizationId: this.app.companyId,
          description: '',
          statusId: Status.Active,
          status: null,
          isValid: true,
          validFromDate: new Date().toISOString(),
          validToDate: this.addyearPipe.transform(new Date()),
          noteComments: null,
          noteAttachments: null,
          createdByName: ''
        },
        statusId: Status.Active,
        status: null
      }
      note.push(notes);
    }
    return note;
  }

  checkTrackingMandatoryPrd() {
    const trackingAdded = this.items?.some(prd => prd.trackingEnabled && prd.availabel > 0
      && prd.billOrderSerialDetail?.length != prd.availabel);
    return trackingAdded;
  }

  updateBill(value) {
    this.appMainService.isShowSpinner('bill');
    this.isDisabled = true;
    if (this.poSerialEnabled && this.checkTrackingMandatoryPrd()) {
      this.messageService.add({
        severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
        detail: "Please add serial details to proceed."
      });
      this.isDisabled = false;
      this.appMainService.isHideSpinner('bill');
      return;
    }
    if (this.utilService.checkSerialNoValidationBill(this.items)) {
      const req = {
        id: this.mode == 'COPY' ? 0 : this.savedBill.id,
        createdSource: this.mode == 'COPY' ? this.app.userIP : this.savedBill.createdSource,
        updatedSource: this.app.userIP,
        createdBy: this.mode == 'COPY' ? this.app.userId : this.savedBill.createdBy,
        updatedBy: this.app.userId,
        createdDate: this.mode == 'COPY' ? new Date().toISOString() : this.savedBill.createdDate,
        updatedDate: new Date().toISOString(),
        number: '',
        name: '',
        description: '',
        organizationId: this.app.companyId,
        userId: value.userId ?? 0,
        purchaseOrderId: 0,
        receivedPurchaseOrderId: 0,
        billDate: this.app._saveDateTimeWithZone(value.billDate),
        warehouseId: this.shipAddress.id,
        contactId: value.contactId,
        shippingAddressId: value?.shippingAddressId,
        totalAmount: this.subTotal,
        currencyUnitId: this.vendorDetails?.currencyId,
        exchangeRate: ((this.reCalculateNotEnabled ? this.previousExchangeRate : this.vendorExchangeRate) ?? 0),
        discountTypeId: this.selectedValueOption?.discountBy ?? 0,
        discountType: null,
        discountId: (this.discount > 0 && this.selectedValueOption) ? this.selectedValueOption?.id : 0,
        discountName: this.discount > 0 ? this.allDiscounts?.find(discount => discount.discountBy === this.selectedValueOption?.id)?.name || '' : '',
        discountAmount: this.discount,
        discountFinancialId: this.discount > 0 ? this.allDiscounts?.find(discount => discount.discountBy === this.selectedValueOption?.id)?.incomeAccount || 0 : 0,
        shippingChargeAmount: this.shippingAmount,
        shippingFinancialId: this.shippingAmount > 0 ? this.allFOBPoints?.find(f => f.isDefault)?.financialAccountId || 0 : 0,
        taxId: 0,
        taxTypeId: 0,
        taxAmount: this.tax,
        otherChargeAmount: 0,
        netAmount: this.amountItem,
        totalExpenseAmount: this.amountExpense,
        billAmount: value.amountDue,
        purchaseOrderStageId: 0,
        purchaseOrderStage: '',
        paymentTermId: (value.paymentTermId ? value.paymentTermId?.paymentTermId : 0),
        paymentMethodId: (value.paymentMethodId ? value.paymentMethodId?.paymentMethodId : 0),
        shippingTermId: (value.shippingTermId ? value.shippingTermId?.id : 0),
        shippingMethodId: (value.shippingMethodId ? value.shippingMethodId?.shippingMethodId : 0),
        statusId: Status.Active,
        isValid: true,
        validFromDate: new Date().toISOString(),
        validToDate: this.addyearPipe.transform(new Date()),
        billOrderProducts: this.setBillProducts(this.items),
        billOrderNotes: this.setNotes(value),
        billOrderExpense: this.setBillExpense(),
        vendorBusinessName: value?.vendorId?.name,
        receivedPurchaseOrderStatus: '',
        createdByUser: this.mode == 'COPY' ? '' : this.savedBill.createdByUser,
        isConverted: this.mode == 'COPY' ? false : this.savedBill?.isConverted,
        vendorId: this.savedBill?.vendorId,
        dueDate: this.app._saveDateTimeWithZone(value.dueDate),
        configJson: JSON.stringify(this.billTemplate),
        referenceNo: value.referenceNo,
        postingDate : this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.savedBill?.postingDate ,
        postingMonth : this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : this.savedBill?.postingMonth ,
        postingYear : this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : this.savedBill?.postingYear 
      }
      const serviceName = this.mode == 'COPY' ? 'createBill' : 'updateNewBill';
      this.purchaseService[serviceName](req, (this.vendorDetails?.currencyId == this.baseCurrency?.currencyId)).then((response) => {
        this.appMainService.isHideSpinner('bill');
        this.isDisabled = false;
        this.displayNewBill = false
        this.loadList.emit();
        this.onClose.emit();
      }).catch(() => {
          this.isDisabled = false;
          this.appMainService.isHideSpinner('bill');
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving data..." });
      });
    } else {
      this.appMainService.isHideSpinner('bill');
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Items you want to add have more serialNo added than qty.." });
      this.isDisabled = false;
    }
  }

  setProductSerialDetails(serialDetails) {
    const tracking = [];
    serialDetails?.forEach(element => {
      const trackEach = {
        id: element.id,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        billOrderId: this.savedBill.id,
        billOrderProductId: element.billOrderProductId,
        barcode: element.barcode,
        serialNumber2: element.serialNumber2,
        serialNumber3: element.serialNumber3,
        serialNumber4: element.serialNumber4,
        serialNumber5: element.serialNumber5,
        serialNumber6: element.serialNumber6,
        serialNumber7: element.serialNumber7,
        serialNumber8: element.serialNumber8,
        serialNumber9: element.serialNumber9,
        serialNumber10: element.serialNumber10,
        serialNumber11: element.serialNumber11,
        serialNumber12: element.serialNumber12,
        serialNumber13: element.serialNumber13,
        serialNumber14: element.serialNumber14,
        serialNumber15: element.serialNumber15,
        serialNumber16: element.serialNumber16,
        serialNumber17: element.serialNumber17,
        lotNumber: element.lotNumber,
        revisionNumber: element.revisionNumber,
        expirationDate: this.app._saveDateTimeWithZone(element.expirationDate),
        statusId: 1
      }
      tracking.push(trackEach);
    });
    return tracking;
  }

  setBundleSerialDetails(trackings) {
    const tracking = [];
    trackings?.forEach(element => {
      const trackEach = {
        id: element.id,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        billOrderProductId: element.billOrderProductId,
        billOrderBundleDetailId: element.billOrderBundleDetailId,
        barcode: element.barcode,
        lotNumber: element.lotNumber,
        revisionNumber: element.revisionNumber,
        expirationDate: this.app._saveDateTimeWithZone(element.expirationDate),
        statusId: 1
      }
      tracking.push(trackEach);
    });
    return tracking;
  }

  setBundleProduct(bundleProducts) {
    const bundle = [];
    bundleProducts?.forEach(element => {
      const bundleEach = {
        id: (element.id ?? 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        billOrderId: this.savedBill.id,
        billOrderProductId: (element.billOrderProductId ?? 0),
        billOrderProduct: '',
        productId: element.productId,
        purchaseOrderNo: element.poNo,
        purchaseOrderId: element.purchaseOrderId,
        subProductId: element.subProductId,
        productUnitId: element.unit?.unitOfMeasureId,
        quantity: element.availabel,
        pricePerProduct: element.price,
        totalAmount: element.cost,
        binId: 0,
        statusId: Status.Active,
        warehouseId: this.shipAddress?.id,
        receivedAmount: 0,
        dueAmount: 0,
        qtyReceived: 0,
        qtyPending: 0,
        billOrderBundleSerialDetail: this.setBundleSerialDetails(element.billOrderBundleSerialDetail),
        isClosed: true,
        orderedQty: 0,
        discountTypeId: 0,
        discountAmount: 0,
        taxId: 0,
        taxTypeId: 0,
        taxRate: 0,
        description: element.description,
        isForceClosed: false,
        receivedProductStatus: '',
        totalQty: element.availabel,
        discountId: 0,
        discountName: '',
        discountFinancialId: 0,
        taxFinancialId: 0,
        taxName: '',
        updateSerial: (element.billOrderBundleSerialDetail ? true : false),
      }
      bundle.push(bundleEach);
    });
    return bundle;
  }

  setBillProducts(prods) {
    const products = [];
    prods?.forEach(element => {
      const prodEach = {
        id: (element.id ?? 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        billOrderId: this.savedBill.id,
        productId: element.productId,
        productUnitId: element.unit?.unitOfMeasureId,
        quantity: element.availabel,
        pricePerProduct: element.price,
        totalAmount: element.cost,
        netAmount: element.lineTotal,
        purchaseOrderNo: element.poNo,
        purchaseOrderId: element.purchaseOrderId,
        binId: 0,
        statusId: Status.Active,
        warehouseId: this.shipAddress.id,
        receivedAmount: 0,
        dueAmount: 0,
        qtyReceived: 0,
        qtyPending: 0,
        billOrderBundleDetail: this.setBundleProduct(element.products),
        billOrderSerialDetail: this.setProductSerialDetails(element.billOrderSerialDetail),
        isClosed: false,
        orderedQty: 0,
        discountTypeId: 0,
        discountAmount: 0,
        taxId: 0,
        taxTypeId: 0,
        taxRate: 0,
        billOrderProductSubTax: this.utilService.setInvBillProductSubTax(element,this.allTaxRates,this.app,this.ordersVendorCountryNew, this.ordersVendorStateNew, this.shipAddress,this.savedBill),
        description: element.description,
        isForceClosed: false,
        receivedProductStatus: '',
        totalQty: element.availabel,
        discountId: 0,
        discountName: '',
        discountFinancialId: 0,
        taxFinancialId: 0,
        taxName: '',
        updateSerial: (element.billOrderSerialDetail ? true : false),
        referenceId: element.referenceId
      }
      products.push(prodEach);
    });
    return products;
  }

  calculateSubTotal(item, qty, price) {
    if (item.typeId != 4) {
      item.cost = (price * qty);
      let productsTotalTax = 0;
      item?.productSubTax?.forEach((sTax) => {
          productsTotalTax += this.utilService.calculateProductsTax(sTax.taxRate, item.cost);
      });
      item.taxAmount = productsTotalTax;
      item.lineTotal = (price * qty * item.unit?.uomDetail?.value) + (this.footerTaxEnabled ? 0 : item.taxAmount);
    } else {
      item.cost = 0;
      for (let prd of item.products) {
        prd.availabel = prd.originalQty * item.availabel;
        prd.cost = prd.availabel * prd.price * prd.unit?.uomDetail?.value;
        item.cost = Number(item.cost) + Number(prd.cost);
      }
    }
    this.calculateItemExpense();
  }

  calculateBundlePrice(bundle, item) {
    item.cost = Number(item.price * item.availabel);
    bundle.cost = 0;
    for (let prd of bundle.products) {
      bundle.cost = Number(bundle.cost) + Number(prd.cost);
    }
    this.calculateItemExpense();
  }

  openScanInfo(product, bundle?) {
    if (this.shipAddress) {
      this.selectedProductForScan = product;
      this.isPrefix = false;
      this.isAutoGenerated = false;
      this.prefixValue = '';
      this.totalTBRecord = 0;
      this.savedOptionSelection = product.serialSettings;
      this.prepareTrackingForm();
      this.displayScanInfo = true;
      const arr: any[] = [];
      if (bundle) {
        this.selectedBundle = bundle;
        this.savedOptionSelection = product.serialSettings;
        if (!product.billOrderBundleSerialDetail) {
          this.purchaseService.getBillProductSerialDetails(this.savedBill.id, this.selectedProductForScan.productId, this.selectedProductForScan?.subProductId).subscribe(res => {
            product.billOrderBundleSerialDetail = res;
            product.billOrderBundleSerialDetail?.forEach((element) => {
              const obj = {
                id: element.id,
                serialNo: element.barcode,
                lotNo: element.lotNumber,
                revisionNo: element.revisionNumber,
                expiration: element.expirationDate && this.app._showDateTimeWithZone(element.expirationDate),
              };
              arr.push(obj);
            });
            this.autoGenerateLists = arr;
            this.nameLists = this.autoGenerateLists.slice(0, 100);
            this.listLength = this.autoGenerateLists.length;
            this.totalTBRecord = this.listLength;
          })
        } else {
          product.billOrderBundleSerialDetail?.forEach((element) => {
            const obj = {
              id: element.id,
              serialNo: element.barcode,
              lotNo: element.lotNumber,
              revisionNo: element.revisionNumber,
              expiration: element.expirationDate && this.app._showDateTimeWithZone(element.expirationDate),
            };
            arr.push(obj);
          });
          this.autoGenerateLists = arr;
          this.nameLists = this.autoGenerateLists.slice(0, 100);
          this.listLength = this.autoGenerateLists.length;
          this.totalTBRecord = this.listLength;
        }
      } else {
        if (!product.billOrderSerialDetail) {
          this.purchaseService.getBillProductSerialDetails(this.savedBill.id, this.selectedProductForScan.productId, 0).subscribe(res => {
            product.billOrderSerialDetail = res;
            product.billOrderSerialDetail?.forEach((element) => {
              const obj = {
                id: element.id,
                serialNo: element.barcode,
                serialNo2: element.serialNumber2,
                serialNo3: element.serialNumber3,
                serialNo4: element.serialNumber4,
                serialNo5: element.serialNumber5,
                serialNo6: element.serialNumber6,
                serialNo7: element.serialNumber7,
                serialNo8: element.serialNumber8,
                serialNo9: element.serialNumber9,
                serialNo10: element.serialNumber10,
                serialNo11: element.serialNumber11,
                serialNo12: element.serialNumber12,
                serialNo13: element.serialNumber13,
                serialNo14: element.serialNumber14,
                serialNo15: element.serialNumber15,
                serialNo16: element.serialNumber16,
                serialNo17: element.serialNumber17,
                lotNo: element.lotNumber,
                revisionNo: element.revisionNumber,
                referenceId: element.referenceId,
                expiration: element.expirationDate && this.app._showDateTimeWithZone(element.expirationDate),
              };
              arr.push(obj);
            });
            this.autoGenerateLists = arr;
            this.nameLists = this.autoGenerateLists.slice(0, 100);
            this.listLength = this.autoGenerateLists.length;
            this.trackingForm.controls['qty'].setValue(this.selectedProductForScan.availabel - this.listLength);
            this.totalTBRecord = this.listLength;
          })
        } else {
          product.billOrderSerialDetail?.forEach((element) => {
            const obj = {
              id: element.id,
              serialNo: element.barcode,
              serialNo2: element.serialNumber2,
              serialNo3: element.serialNumber3,
              serialNo4: element.serialNumber4,
              serialNo5: element.serialNumber5,
              serialNo6: element.serialNumber6,
              serialNo7: element.serialNumber7,
              serialNo8: element.serialNumber8,
              serialNo9: element.serialNumber9,
              serialNo10: element.serialNumber10,
              serialNo11: element.serialNumber11,
              serialNo12: element.serialNumber12,
              serialNo13: element.serialNumber13,
              serialNo14: element.serialNumber14,
              serialNo15: element.serialNumber15,
              serialNo16: element.serialNumber16,
              serialNo17: element.serialNumber17,
              lotNo: element.lotNumber,
              revisionNo: element.revisionNumber,
              expiration: element.expirationDate && this.app._showDateTimeWithZone(element.expirationDate),
            };
            arr.push(obj);
          });
          this.autoGenerateLists = arr;
          this.nameLists = this.autoGenerateLists.slice(0, 100);
          this.listLength = this.autoGenerateLists.length;
          this.trackingForm.controls['qty'].setValue(this.selectedProductForScan.availabel - this.listLength);
          this.totalTBRecord = this.listLength;
        }
      }
      this.checkSerialNoInSystem((bundle ? this.selectedProductForScan?.subProductId : this.selectedProductForScan?.productId), this.shipAddress?.id);
      // Apply the custom validator after initializing the form
      if (!this.utilService.hasRequiredValidator(this.trackingForm)) {
        this.trackingForm.setValidators(this.utilService.atLeastOneFieldValidator([
          'lotNo', 'revisionNo', 'expiration',
          'serialNo', 'serialNo2', 'serialNo3', 'serialNo4', 'serialNo5',
          'serialNo6', 'serialNo7', 'serialNo8', 'serialNo9', 'serialNo10',
          'serialNo11', 'serialNo12', 'serialNo13', 'serialNo14', 'serialNo15',
          'serialNo16', 'serialNo17'
        ]));
        this.trackingForm.updateValueAndValidity(); // Ensure validation is applied
      }
    } else {
      this.messageService.add({
        severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
        detail: "Please select shipping first.",
      });
    }
  }

  get isFormIncomplete(): boolean {
    return Object.keys(this.trackingForm.controls).some(key => {
      if (key === 'serialNo') return false;
      const control = this.trackingForm.get(key);
      const isRequired = control?.validator?.({} as AbstractControl)?.['required'];
      const isEmpty = !control?.value || control.value.toString().trim() === '';
      return isRequired && isEmpty;
    });
  }

  /**tracking SerialNo**/
  prepareTrackingForm() {
    const qty = this.selectedProductForScan?.availabel;
    this.trackingForm = this.fb.group({
      qty: [(qty - this.listLength), [Validators.required]],
      lotNo: [""],
      revisionNo: [""],
      expiration: [""],
      serialNo: [""],
      serialNo2: [""],
      serialNo3: [""],
      serialNo4: [""],
      serialNo5: [""],
      serialNo6: [""],
      serialNo7: [""],
      serialNo8: [""],
      serialNo9: [""],
      serialNo10: [""],
      serialNo11: [""],
      serialNo12: [""],
      serialNo13: [""],
      serialNo14: [""],
      serialNo15: [""],
      serialNo16: [""],
      serialNo17: [""],
      packageBarcode: [""],
    });
    /**set validation for Tracking form**/
    for (let opt of this.trackingOptions) {
      if (opt.enabled && (this.savedOptionSelection ? this.savedOptionSelection[`${opt.code}`] : true)) {
        if (opt.field !== 'serialNo' && opt.isRequired) {
          this.trackingForm.get(`${opt.field}`).setValidators(Validators.required);
        } else if (opt.field === 'serialNo' && opt.isRequired) {
          if (this.utilService.displayName('serializedChecked', this.trackingOptions, 'control') == 'InputBox') {
            this.trackingForm.get(`${opt.field}`).setValidators([Validators.required, Validators.pattern(/^[A-Za-z0-9-]*$/)]);
          } else {
            this.trackingForm.get(`${opt.field}`).setValidators([Validators.required]);
          }
        } else {
          this.trackingForm.get(`${opt.field}`).clearValidators();
        }
        this.trackingForm.get(`${opt.field}`).updateValueAndValidity();
      }
    }
  }

  countNameList(value) {
    if (this.trackingForm.valid && this.listLength < this.selectedProductForScan?.availabel) {
      if (value.serialNo) {
        value.serialNo = (this.isPrefix ? this.prefixValue.concat(value.serialNo) : value.serialNo);
        const duplicate = this.autoGenerateLists?.filter(sr => sr.serialNo == value.serialNo);
        const present = this.systemTrackingData?.find(sr => sr.serialNo == value.serialNo);
        for (let prd of this.items) {
          const prdDuplicate = prd.billOrderSerialDetail?.filter(sNo => sNo.barcode == value.serialNo);
          if (prdDuplicate?.length > 0) {
            this.messageService.add({
              severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
              detail: "Duplicate serialNo found.",
            });
            return
          }
          if (prd.products?.length > 0) {
            for (let bundle of prd.products) {
              const bundleDuplicate = bundle.billOrderBundleSerialDetail?.filter(sNo => sNo.barcode == value.serialNo);
              if (bundleDuplicate?.length > 0) {
                this.messageService.add({
                  severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
                  detail: "Duplicate serialNo found.",
                });
                return
              }
            }
          }
        }
        if (duplicate?.length > 0) {
          this.messageService.add({
            severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
            detail: "Serial No you tried to enter is already present in below list.",
          });
        } else if (present) {
          this.messageService.add({
            severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
            detail: "Serial No you tried to enter is already present for this product.",
          });
        } else {
          this.checkSerialsForSystem(value.serialNo, this.selectedProductForScan?.id, this.shipAddress?.id, value);
        }
      } else if (!value.serialNo) {
        const totalQty = this.selectedProductForScan?.availabel;
        for (let i = 0; i < (value.qty); i++) {
          if (this.listLength < totalQty) {
            this.autoGenerateLists.push({ ...value });
            this.listLength++;
          }
        }
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.totalTBRecord = this.listLength;
        this.trackingForm.controls['qty'].setValue(totalQty - this.listLength);
      }
    }
    const controlNames = Object.keys(this.trackingForm.controls);
    for (let ctrl of controlNames) {
      if (this.trackingOptions?.find((el) => (el.field === ctrl))?.clearField) {
        this.trackingForm.controls[`${ctrl}`].setValue("");
      }
    }
  }

  checkSerialsForSystem(serialNo, productId, warehouseId, value) {
    this.purchaseService.checkSerialNoInAllSystem(serialNo, warehouseId, productId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
      if (res.allowSave) {
        this.autoGenerateLists.push(value);
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.listLength + 1;
        this.totalTBRecord = this.listLength;
        const qty = this.selectedProductForScan.availabel;
        this.trackingForm.controls['qty'].setValue(qty - this.listLength)
      } else {
        this.messageService.add({ severity: "error", summary: "Error", detail: "SerialNo you tried to import is already associated with other product,you can't add." });
      }
    });
  }

  saveSerializedNo(c) {
    if (this.selectedBundle) {
      this.selectedBundle.products?.forEach((element) => {
        if (element.subProductId == this.selectedProductForScan.subProductId) {
          element.billOrderBundleSerialDetail = [];
          this.autoGenerateLists.forEach((nl) => {
            const obj = {
              id: (nl.id ? nl.id : 0),
              createdSource: this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.userId,
              updatedBy: this.app.userId,
              createdDate: new Date().toISOString(),
              updatedDate: new Date().toISOString(),
              billOrderProductId: (this.selectedBundle?.id),
              billOrderBundleDetailId: (this.selectedProductForScan?.id ? this.selectedProductForScan.id : 0),
              barcode: nl.serialNo,
              lotNumber: nl.lotNo,
              revisionNumber: nl.revisionNo,
              expirationDate: nl.expiration,
              statusId: 1
            };
            element.billOrderBundleSerialDetail.push(obj);
          });
        }
      });
    } else {
      this.items.forEach((element) => {
        if (element.productId == this.selectedProductForScan.productId) {
          element.billOrderSerialDetail = [];
          this.autoGenerateLists.forEach((nl) => {
            const obj = {
              id: (nl.id ? nl.id : 0),
              createdSource: this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.userId,
              updatedBy: this.app.userId,
              createdDate: new Date().toISOString(),
              updatedDate: new Date().toISOString(),
              billOrderProductId: this.selectedProductForScan.id,
              barcode: nl.serialNo,
              serialNumber2: nl.serialNo2,
              serialNumber3: nl.serialNo3,
              serialNumber4: nl.serialNo4,
              serialNumber5: nl.serialNo5,
              serialNumber6: nl.serialNo6,
              serialNumber7: nl.serialNo7,
              serialNumber8: nl.serialNo8,
              serialNumber9: nl.serialNo9,
              serialNumber10: nl.serialNo10,
              serialNumber11: nl.serialNo11,
              serialNumber12: nl.serialNo12,
              serialNumber13: nl.serialNo13,
              serialNumber14: nl.serialNo14,
              serialNumber15: nl.serialNo15,
              serialNumber16: nl.serialNo16,
              serialNumber17: nl.serialNo17,
              lotNumber: nl.lotNo,
              revisionNumber: nl.revisionNo,
              expirationDate: nl.expiration,
              statusId: 1
            };
            element.billOrderSerialDetail.push(obj);
          });
        }
      });
    }
    this.selectedProductForScan = null;
    this.selectedBundle = null;
    this.listLength = 0;
    this.displayScanInfo = false;
  }

  setMainHeaderTracking() {
    const checked = this.nameLists.filter(ch => ch.checked);
    if (checked.length == this.nameLists?.length) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }

  removeNumber(i) {
    this.nameLists.splice(i, 1);
    this.autoGenerateLists.splice(i, 1);
    this.nameLists = this.autoGenerateLists.slice(0, 100);
    this.listLength--;
    this.totalTBRecord = this.listLength;
    const qty = this.selectedProductForScan.availabel;
    this.trackingForm.controls['qty'].setValue(qty - this.listLength)
  }

  deleteAll() {
    this.autoGenerateLists = [];
    this.nameLists = [];
    this.listLength = 0;
    this.totalTBRecord = 0;
    const qty = this.selectedProductForScan.availabel;
    this.trackingForm.controls['qty'].setValue(qty)
  }

  setTableCheck() {
    for (let s of this.autoGenerateLists) {
      if (this.allChecked) {
        s.checked = true;
      } else {
        s.checked = false;
      }
    }
  }
  //tracking
  openImport() {
    this.importCount = (this.selectedProductForScan?.availabel);
    this.displayImport = true;
  }

  hideImport() {
    this.displayImport = false;
  }

  onCompleteSearchProduct(e) {
    const data = {
      vendorId: this.billForm.controls['vendorId']?.value.id,
      pageNumber: 1,
      pageSize: 15,
      searchValue: e.target.value,
    }
    this.purchaseService.getWarehouseWiseProductBarcode(data)
      .then((products) => {
        let { inventory, headers } = products;
        inventory = inventory == null ? [] : inventory;
        headers = headers == null ? [] : headers;
        this.scanedProductsList = this.productDataService.prepareProductsList(inventory);
        this.searchValue = "";
        this.scanedProductsList.forEach(element => {
          element.availabel = element.addQty;
          element.products = element.bundleDetails;
          element.price = element.costPrice;
          if (element.products?.length > 0) {
            for (let prd of element.products) {
              prd.availabel = prd.ordQty;
              prd.currentVal = prd.availabel;
              prd.price = prd.costPrice;
            }
          }
          const productExist = this.items.find(p => p.id == element.id);
          if (productExist) {
            productExist.availabel = Number(productExist.availabel) + Number(element.addQty);
          } else {
            element.billOrderSerialDetail = [];
            //element.billOrderBundleDetail=[];
            this.items.push(element);
          }
          this.items.forEach((element) => {
            element.cost = 0;
            element.cost = element.price * element.availabel;
            if (element.products?.length > 0) {
              element.cost = 0;
              for (let prd of element.products) {
                prd.cost = 0;
                prd.billOrderBundleSerialDetail = [];
                //prd.availabel = prd.availabel * element.availabel;
                prd.availabel = prd.originalQty * element.availabel * element.unit?.uomDetail?.value;
                prd.cost = prd.price * prd.availabel;
                element.cost = Number(element.cost) + Number(prd.cost);
              }
            }
          });
          this.calculateItemExpense();
        });
      })
      .finally(() => {
      });

  }

  generate() {
    if (this.isFormIncomplete) {
      this.messageService.add({ severity: "error", summary: "Error", detail: "Please fill all required fields." });
      return
    }
    const length = (this.selectedProductForScan?.availabel - this.listLength);
    this.autoGenerateLists = this.utilService.autogenerateSerial(this.trackingForm.value, this.prefixValue, this.autoGenerateLists, length);
    for (let auto of this.autoGenerateLists) {
      auto.expiration = auto.expiration && new Date(auto.expiration)
    }
    this.totalTBRecord = this.autoGenerateLists.length;
    this.nameLists = this.autoGenerateLists.slice(0, 100);
    this.listLength = this.selectedProductForScan?.availabel;
  }

  loadSerialsLazy(event) {
    if (this.autoGenerateLists) {
      this.nameLists = this.autoGenerateLists.slice(
        event.first,
        event.first + event.rows
      );
    }
  }

  importSerialData(data) {
    /*check whether same file is importing for all product in RPO*/
    for (let dt of data.list) {
      for (let prd of this.items) {
        const prdDuplicate = prd.billOrderSerialDetail?.filter(sNo => (prd.productId != this.selectedProductForScan.productId && sNo.barcode == dt.serialNo));
        if (prdDuplicate?.length > 0) {
          this.messageService.add({
            severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error),
            detail: "You are trying to import same serialNo for different product in RPO",
          });
          return
        }
      }
    }
    if (data.action == 'add') {
      for (let dt of data.list) {
        const index = this.autoGenerateLists?.findIndex(exp => exp.serialNo == dt.serialNo);
        if (index > -1) {
          dt.id = this.autoGenerateLists[index].id;
          this.autoGenerateLists[index] = dt;
        } else {
          if ((this.listLength < this.selectedProductForScan?.availabel) && this.utilService.hasSerialNo(dt.serialNo, this.systemTrackingData)) {
            this.autoGenerateLists.push(dt);
            this.listLength++;
          }
        }
      }
    } else {
      // Get the total quantity from the form control
      const totalQty = this.selectedProductForScan.availabel || 0;
      const uniqueList = data.list?.filter(dt => this.utilService.hasSerialNo(dt.serialNo, this.systemTrackingData));
      const filteredList = uniqueList.slice(0, totalQty);
      // Fields to skip when comparing
      const skipKeys = ['id', 'expiration', 'field1', 'field2', 'field3', 'field4', 'field5', 'field6', 'field7', 'field8',
        'field9', 'field10', 'field11', 'field12', 'field13', 'field14', 'field15', 'field16', 'field17', 'field18', 'field19',
        'field20'
      ];
      // Compare only defined + non-empty fields from newItem against existingItem
      const isMatch = (existingItem: any, newItem: any): boolean => {
        for (const key in newItem) {
          if (skipKeys.includes(key)) continue;

          const newVal = newItem[key];
          if (newVal !== undefined && newVal !== null && newVal !== '') {
            if (existingItem[key] !== newVal) return false;
          }
        }
        return true;
      };
      // Step 1: Update existing items
      let updatedList = this.autoGenerateLists.map(existingItem => {
        const match = filteredList.find(newItem => isMatch(existingItem, newItem));
        if (match) {
          return {
            ...existingItem,
            ...Object.keys(match).reduce((acc, key) => {
              acc[key] = match[key] !== undefined && match[key] !== ''
                ? match[key]
                : existingItem[key]; // preserve existing if new is blank
              return acc;
            }, {} as any)
          };
        }
        return existingItem;
      });
      // Step 2: Remove items not found in filteredList
      updatedList = updatedList.filter(existingItem =>
        filteredList.some(newItem => isMatch(existingItem, newItem))
      );
      // Step 3: Add new items not present in updatedList
      filteredList.forEach(newItem => {
        const exists = updatedList.some(existingItem => isMatch(existingItem, newItem));
        if (!exists) {
          updatedList.push(newItem);
        }
      });
      this.autoGenerateLists = updatedList;
    }
    this.nameLists = this.autoGenerateLists.slice(0, 100);
    this.totalTBRecord = this.listLength;
    this.disabledSave = false;
    this.displayImport = false;
    const qty = this.selectedProductForScan.availabel;
    this.trackingForm.controls['qty'].setValue(qty - this.listLength)
    this.messageService.add({
      severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success),
      detail: "Import successfully,removed duplicate Serial No.",
    });
  }

  saveImport(data) {
    //assign refId to prd
    const filteredPrd = this.items.find((element) => element.productId == this.selectedProductForScan.productId);
    filteredPrd.referenceId = data.referenceId;
    //duplicate file import
    const unique = data.list?.filter((obj) => {
      const autoIndex = this.autoGenerateLists.findIndex(item => item.serialNo === obj.serialNo);
      const hasBlankSerialNo = this.autoGenerateLists.some(item => item.serialNo === "");

      return autoIndex === -1 || hasBlankSerialNo;
    }) || [];

    const qty = (this.selectedProductForScan?.availabel - this.listLength);
    if (unique.length > 0 && (data.list?.length - unique.length) > qty) {
      this.confirmationService.confirm({
        message: "You cannot import serial numbers more than ordered qty,Do you still want to proceed?",
        header: "Alert Confirmation",
        icon: "pi pi-info-circle",
        accept: () => {
          this.importSerialData(data);
        },
        reject: () => { },
      });
    } else {
      this.importSerialData(data);
    }
  }

  checkSerialNoInSystem(productId, warehouseId) {
    this.purchaseService.checkSerialNoInSystem(warehouseId, productId, false, 0, this.savedBill.id).subscribe(data => {
      this.systemTrackingData = data;
    })
  }

  resetDialog() {
    this.billForm.reset();
  }

  closeDialog() {
    this.displayNewBill = false;
    this.onClose.emit();
  }

  setContentInEditor(text: any) {
    setTimeout(() => {
      const _quill = this.editor.getQuill();
      const editorContainer = _quill.root;
      this.renderer.setProperty(editorContainer, 'innerHTML', text);
    });
  }
  onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
    this.updatedPostingPeriodInfo = postingInfo;
  }

  // Tax Selection
  async getTaxByAddress(countryId: number) {
    const taxData: any = await this.utilService.getTaxByCountryId(countryId);
    this.taxSettings = taxData.taxSettings ?? null;
    this.allTaxRates = taxData?.allTaxRates ?? [];
    this.taxConfig = taxData.taxConfig ?? null;
  }

  openTax(product: any) {
    this.currentProduct = product;
    this.selectedTax = product?.productSubTax ?? [];
    this.taxDialogContext = 'product';
    this.displayTaxSelectionDialog = true;
  }

  openFooterTax() {
    const allTaxes = this.items?.flatMap((product) => {
      return product.productSubTax || [];
    });
    this.selectedTax = this.getUniqueTaxes(allTaxes);
    this.taxDialogContext = 'footer';
    this.displayTaxSelectionDialog = true;
  }

  private getUniqueTaxes(taxes: any[]): any[] {
    const uniqueTaxMap = new Map();
    taxes?.forEach((tax) => {
      if (!uniqueTaxMap.has(tax.taxId)) {
        uniqueTaxMap.set(tax.taxId, tax);
      }
    });
    return Array.from(uniqueTaxMap.values());
  }

  applyTax(event: TaxSelectionModel) {
    this.displayTaxSelectionDialog = false;
    this.selectedTax = null;
    if (this.taxDialogContext === 'product') {
      this.currentProduct.productSubTax = event.selectedTaxes;
      this.currentProduct.isManualTaxApplied = true;
      this.calculateSubTotal(this.currentProduct, this.currentProduct.availabel, this.currentProduct.price);
    } else if (this.taxDialogContext === 'footer') {
      this.items = this.items.map(product => ({
        ...product,
        productSubTax: event.selectedTaxes,
        isManualTaxApplied: true
      }));
      this.items?.forEach((item) => {
        let productsTotalTax = 0;
        item?.productSubTax?.forEach((sTax) => {
          productsTotalTax += this.utilService.calculateProductsTax(sTax.taxRate, item.cost);
        });
        item.taxAmount = productsTotalTax;
      })
      this.calculateItemExpense();
    }
  }

  onCloseTaxSelectionDialog(event: any) {
    this.displayTaxSelectionDialog = false;
  }
  // End of Tax Selection
}
